import { MINUTE_IN_MILLISECONDS } from "shared/constants";
import Poller from "shared/services/polling/Poller";
import { useMentionCountsStore } from "shared/stores/mentionCounts";

function callback() {
  // Returned so Poller awaits it before scheduling the next tick. The Axios
  // timeout is 120s, twice this interval, so without this a slow request can
  // be raced by the next one and resolve out of order.
  return useMentionCountsStore().fetchMentionCounts();
}

export default new Poller({ callback, interval: MINUTE_IN_MILLISECONDS });
